module.exports = __webpack_public_path__ + "static/media/19.slack.218b9179.svg";